import {
    NEW_VENDA_ANIMAL_SUCCESS,
    TABLE_VENDA_ANIMAL_PENDING,
    TABLE_VENDA_ANIMAL_SUCCESS,
    TABLE_VENDA_ANIMAL_FAILURE,
    LIST_VENDA_ANIMAL_PENDING,
    LIST_VENDA_ANIMAL_SUCCESS,
    LIST_VENDA_ANIMAL_FAILURE,
    FIND_VENDA_ANIMAL_PENDING,
    FIND_VENDA_ANIMAL_SUCCESS,
    FIND_VENDA_ANIMAL_FAILURE,
    DELETE_VENDA_ANIMAL_PENDING,
    DELETE_VENDA_ANIMAL_SUCCESS,
    DELETE_VENDA_ANIMAL_FAILURE,
    CREATE_VENDA_ANIMAL_PENDING,
    CREATE_VENDA_ANIMAL_SUCCESS,
    CREATE_VENDA_ANIMAL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function vendaAnimalReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_VENDA_ANIMAL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_VENDA_ANIMAL_PENDING:
        case FIND_VENDA_ANIMAL_PENDING:
        case DELETE_VENDA_ANIMAL_PENDING:
        case CREATE_VENDA_ANIMAL_PENDING:
        case TABLE_VENDA_ANIMAL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_VENDA_ANIMAL_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_VENDA_ANIMAL_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_VENDA_ANIMAL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_VENDA_ANIMAL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_VENDA_ANIMAL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_VENDA_ANIMAL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_VENDA_ANIMAL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_VENDA_ANIMAL_SUCCESS:
        case CREATE_VENDA_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_VENDA_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { vendaAnimalReducer };